// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".Rating-Box{width:106px;position:relative}.Rating-Current{display:flex;overflow:hidden;position:absolute;top:0;left:0}.Rating-Star{stroke:#2196f3;flex-shrink:0}.Rating-Star:not(:last-of-type){margin-right:4px}.Rating-Star_filled{fill:#2196f3;stroke:#2196f3}\n", ""]);
// Exports
module.exports = exports;
